export * from './defaultLightsDescription';
export * from './defaultOrthographicCameraDescription';
export * from './defaultPerspectiveCameraDescription';
export * from './defaultRendererDescription';
